import { render, staticRenderFns } from "./StudentStudy.vue?vue&type=template&id=d0f5774c&scoped=true"
import script from "./StudentStudy.vue?vue&type=script&lang=js"
export * from "./StudentStudy.vue?vue&type=script&lang=js"
import style0 from "./StudentStudy.vue?vue&type=style&index=0&id=d0f5774c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f5774c",
  null
  
)

export default component.exports